import { render, staticRenderFns } from "./RecintoAnexoComponent.vue?vue&type=template&id=6d2274a0"
import script from "./RecintoAnexoComponent.vue?vue&type=script&lang=js"
export * from "./RecintoAnexoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports